/* Sharrow Origin Story scripts (converted from Squarespace). */

/* Keep a background video covering its box at any size. */
(function(){
  function cover(box, prefix){
    if(!box || box.dataset.coverReady==='1') return;
    box.dataset.coverReady='1';
    const fit=()=>{
      const r=box.getBoundingClientRect();
      if(r.width<=0||r.height<=0) return;
      const w=Math.max(r.width,r.height*16/9);
      box.style.setProperty(prefix+'-cover-width',w+'px');
      box.style.setProperty(prefix+'-cover-height',(w*9/16)+'px');
    };
    fit();
    if('ResizeObserver' in window) new ResizeObserver(fit).observe(box);
    else window.addEventListener('resize',fit,{passive:true});
  }
  window.SharrowCoverVideo=cover;
})();


window.SharrowCoverVideo(document.querySelector("#sharrow-origin-story > .so-hero .so-hero-video"), "--so");

